import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import axios from 'axios';

import { Header, Table, Button, List, Segment, Grid, Icon } from 'semantic-ui-react';

import ProcessRow from './ProcessRow';
import FileUploadForm from './FileUploadForm';

import { openPreview } from "../../../reducers/publish";

import config from '../../../config';

const UnknownFiles = ({ files, loading }) => (
  <Fragment>
    <Header as='h4'>{'Prosessien ulkopuoliset tiedostot'}</Header>
    <Segment loading={loading}>
      <List divided relaxed>
        {files.map(file => (
          <List.Item key={file.name}>{file.name}</List.Item>
        ))}
      </List>
    </Segment>
  </Fragment>

);

const PdfFiles = ({ files, loading, organization }) => (
  <Fragment>
    <Header as='h4'>Kaavamääräykset (PDF-tiedostot)</Header>
    <Button
      onClick={e => {
        // TODO: refactor
        // this.props.refreshFiles();
        axios.get(config.api.copyPdfFiles);
        console.log(config.api.copyPdfFiles);
      }}
      content="Julkaise kaikki"
    />
    <Table celled structured compact='very' /*loading={loading} TODO: loading doesn't work for Table, create something else */ >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width='3'>Tiedosto</Table.HeaderCell>
          <Table.HeaderCell width='2' textAlign='center'>Julkaistu</Table.HeaderCell>
          <Table.HeaderCell width='2' textAlign='center'>Ladattu</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {files.sort().map((file, i) => (
          <Table.Row key={i}>
            <Table.Cell textAlign='left'>
              {file.name}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {file.is_published ? <a href={`${config.hostUrl}/files/${organization}/${file.name}`} target={'_blank'}>{'Avaa katseluun'}</a> : <span>{''}</span>}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {file.is_uploaded ? <span>{'X'}</span> : <span>{'-'}</span>}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </Fragment>

);
// TODO: FtpFiles and WebFiles logic is all messed up
class ProcessTable extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      pending: true, // Wait for the ftp files
      runningJobs: [], // Jobs that are currently running or pending.
      processes: {},
      webFiles: [],
      unknownFiles: []
    }
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    // Check the pending status
    newState.pending = props.files ? false : true;

    /* empty data */
    newState.webFiles = [];
    newState.unknownFiles = [];
    newState.processes = {
      srs: "EPSG:3067",
      layers: {}
    };

    /* fetched data */
    if (props.files.files) {
        if (props.files.files.hasOwnProperty('process')) {
          newState.processes = props.files.files.process;
        }
        if (props.files.files.hasOwnProperty('web_files')) {
          newState.webFiles = props.files.files.web_files;
        }
        if (props.files.files.hasOwnProperty('unknown_files')) {
          newState.unknownFiles = props.files.files.unknown_files;
        }
    }

    const availableStatus = ['pending', 'started']
    newState.runningJobs = props.jobs.jobs
      .filter(job => availableStatus.includes(job.status))
      .map(job => job.input.layer_name);

    return newState;
  }

  render() {

    return (
      <Fragment>
        <Header as='h2'>Määritetyt tasot 
          <Button
            basic
            onClick={e => {
              this.props.refreshFiles();
            }}
            content={<Icon name='refresh' />} //"Päivitä näkymä"
          />
        </Header>
        <Grid columns={1} relaxed='very'>
          <Grid.Column>
            <div style={{ marginTop: 10 }}>
              <FileUploadForm />
            </div>
          </Grid.Column>
        </Grid>
        {this.state.processes ?
          <Table celled structured compact='very'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width='3'>Tason nimi</Table.HeaderCell>
                <Table.HeaderCell width='2'>Tiedostot</Table.HeaderCell>
                <Table.HeaderCell colSpan='3' width='2'></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {Object.entries(this.state.processes.layers).sort((a,b) => a[1].name.localeCompare(b[1].name)).map(([key, value]) =>
                <ProcessRow
                  key={key}
                  name={key}
                  process={value}
                  isRunning={this.state.runningJobs.includes(key)}
                  isAvailable={value.missing_files.length === 0}
                  pending={this.state.pending}
                  openPreview={this.props.openPreview}
                  workspace={this.props.user.user.organization}
                />
              )}
            </Table.Body>
          </Table> :
          <p>Ei tietoja</p>
        }
        {window.location.href.startsWith("https://kunnat") ? <PdfFiles files={this.state.webFiles} loading={this.state.pending} organization={this.props.user.user.organization} /> : null}
        {<UnknownFiles files={this.state.unknownFiles.sort()} loading={this.state.pending} />}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    jobs: state.jobs,
    files: state.files
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  openPreview: (workspace, layer, displayName, apikey) => openPreview(workspace, layer, displayName, apikey),
}, dispatch);



export default connect(mapStateToProps, mapDispatchToProps)(ProcessTable);



// WEBPACK FOOTER //
// ./src/containers/main/processes/index.js